import React, { useEffect, useState } from 'react';
import { Text, Button, Row, FlexView, Col, Separator } from '@cuemath/comps';
import { COLORS } from '@cuemath/comps';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Message } from 'modules/form';
import { GRADE_OPTIONS } from 'utils';
import { Input, Asterisk, Label, SelectInput } from 'modules/form';
import { closeModal } from 'actions/modal';
import { useChangeGradePatch } from 'actions/change-crm-grade';

const Wrapper = styled.div`
  padding: 40px 10px 20px;
`;

export const SelectInputWrapper = styled(SelectInput)`
  width: 140px;
  height: 40px;
  padding: 5px 10px;
  outline: none;
  display: inline-block;
  &:focus {
    border: 3px solid #c4dffe;
    &::placeholder {
      opacity: 0;
    }
  }
`;

let timeout = null;

const ChangeCrmGrade = ({ student }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ grade: '' });
  const { grade: grade } = form || {};
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { student_id: studentId } = student || {};

  useEffect(() => {
    return () => {
      clearTimeout(timeout);
      timeout = null;
    };
  });

  const onChangeGradePatchComplete = (errorMsg, data) => {
    const { parent_id: parentId } = data || {};

    if (parentId) {
      setSuccess('Grade assigned successfully.');
      timeout = setTimeout(() => dispatch(closeModal()), 2000);
    } else {
      setError(errorMsg || 'something went wrong');
    }
  };

  const { patch: changeGradePatch, isProcessing } = useChangeGradePatch({
    onComplete: onChangeGradePatchComplete,
  });

  const changeExtension = selectedGrade => {
    setForm(prev => ({ ...prev, grade: selectedGrade.value }));
  };

  const onConfirm = () => {
    setError('');
    const payload = {
      grade: grade,
      action: 'CHANGE_GRADE',
    };
    changeGradePatch(studentId, payload);
  };

  const isDisabled = isProcessing || !grade;

  return (
    <Wrapper>
      <Text color={COLORS.BLACK} size="large" weight="bolder" align="center">
        Assign New Grade to Student
      </Text>
      <Separator height={16} transparent />
      <Row alignItems="center">
        <Col>
          <Label style={{ width: '200px' }}>
            {'Grade:'}
            <Asterisk>*</Asterisk>
          </Label>
        </Col>
        <Row alignItems="center">
          <SelectInputWrapper
            name="grade"
            onChange={changeExtension}
            options={GRADE_OPTIONS}
          />
        </Row>
      </Row>
      <Separator height={16} transparent />
      <FlexView flexDirection="row" justifyContent="center" alignItems="center">
        {success ? (
          <Message width="100%">{success}</Message>
        ) : (
          <Button
            align="center"
            label="Submit"
            onClick={onConfirm}
            disabled={isDisabled}
          />
        )}
      </FlexView>
      {error && (
        <Message width="100%" error>
          {error}
        </Message>
      )}
      <Separator height={40} transparent />
      <Text color={COLORS.BLACK} size="small" weight="bolder" align="left">
        Note: This function relates to modifying the grade within the CRM system.
      </Text>
    </Wrapper>
  );
};

export default ChangeCrmGrade;
